// Imports: local files.
import {
  GET_ALL_SKILLS_START,
  GET_ALL_SKILLS_SUCCESS,
  GET_ALL_SKILLS_FAILED,
  GET_ALL_SKILLS_RESET,
  GET_ONE_SKILL_START,
  GET_ONE_SKILL_SUCCESS,
  GET_ONE_SKILL_FAILED,
  GET_ONE_SKILL_RESET,
  CREATE_SKILL_START,
  CREATE_SKILL_SUCCESS,
  CREATE_SKILL_FAILED,
  CREATE_SKILL_RESET,
  UPDATE_ONE_SKILL_START,
  UPDATE_ONE_SKILL_SUCCESS,
  UPDATE_ONE_SKILL_FAILED,
  UPDATE_ONE_SKILL_RESET,
  DELETE_ONE_SKILL_START,
  DELETE_ONE_SKILL_SUCCESS,
  DELETE_ONE_SKILL_FAILED,
  DELETE_ONE_SKILL_RESET,
} from "../actions/actions";

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const skillsReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Skills
     * =======================================================================
     */
    case GET_ALL_SKILLS_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_SKILLS_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_SKILLS_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_SKILLS_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Skill
     * =======================================================================
     */
    case GET_ONE_SKILL_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_SKILL_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_SKILL_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_SKILL_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create New Skill
     * =======================================================================
     */
    case CREATE_SKILL_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_SKILL_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_SKILL_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_SKILL_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Skill
     * =======================================================================
     */
    case UPDATE_ONE_SKILL_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_SKILL_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_SKILL_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_SKILL_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Skill
     * =======================================================================
     */
    case DELETE_ONE_SKILL_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_SKILL_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_SKILL_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_SKILL_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default skillsReducer;
